var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapanese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_172_1290",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V23H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_172_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.9375 0H32.9375V23H-1.9375V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5024 18.6503C19.4938 18.6503 22.7295 15.4494 22.7295 11.5009C22.7295 7.55243 19.4938 4.35156 15.5024 4.35156C11.5111 4.35156 8.27539 7.55243 8.27539 11.5009C8.27539 15.4494 11.5111 18.6503 15.5024 18.6503Z",
    fill: "#D30000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapanese);
export default __webpack_public_path__ + "static/media/Japanese.aeded79e8fe3880a95786efe5cee5628.svg";
export { ForwardRef as ReactComponent };